import React from 'react';

const rebrandingDangerIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
    >
        <g id="symbol-alert-circle-filled">
            <path
                id="fill"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.00684 12C9.0444 12 11.5068 9.53757 11.5068 6.5C11.5068 3.46243 9.0444 1 6.00684 1C2.96927 1 0.506836 3.46243 0.506836 6.5C0.506836 9.53757 2.96927 12 6.00684 12ZM6.75684 4.5V3H5.25684V4.5L5.50684 8H6.50684L6.75684 4.5ZM6.75684 9.25C6.75684 9.66421 6.42105 10 6.00684 10C5.59262 10 5.25684 9.66421 5.25684 9.25C5.25684 8.83579 5.59262 8.5 6.00684 8.5C6.42105 8.5 6.75684 8.83579 6.75684 9.25Z"
                fill="#CC0D11"
            />
        </g>
    </svg>
);

export default rebrandingDangerIcon;
